module.exports = __webpack_public_path__ + "img/solicitud.b3103dca.png";